import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';
import { MainService } from '../../services/main-service.service'

@Directive({
    selector: '[hideIfDecimal]'
})
export class HideIfDecimalDirective implements OnInit {

    constructor(private el: ElementRef, private renderer: Renderer2, private _mainservice: MainService) { }

    ngOnInit() {
        if (this._mainservice.noDecimalCurrencies.includes(this._mainservice.currency_data.currency_code.toLowerCase())) {
            this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
        }
    }
}
